import { SEARCH_CONFIG } from '../searchFlyoutConfig';

export const getInventories = Object.keys(SEARCH_CONFIG) as (keyof typeof SEARCH_CONFIG)[];
